import AccountCircleIcon from "@mui/icons-material/AccountCircle";

interface SignUpProfileProps {
  image?: string;
  name?: string;
  width?: string;
}

export default function SignUpProfile({ width, image, name }: SignUpProfileProps) {
  return (
    <div
      style={{
        width: width ?? "14%",

        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "flex-start",
      }}
    >
      {image ? (
        <img
          style={{
            width: "40px",
            height: "40px",
            maxWidth: "40px",
            maxHeight: "40px",
            borderRadius: "20px",
            marginRight: "12px",
          }}
          src={image}
          alt="profile"
        />
      ) : (
        <AccountCircleIcon
          style={{
            width: "40px",
            height: "40px",
            maxWidth: "40px",
            maxHeight: "40px",
            borderRadius: "20px",
            color: "#eeeeee",
            marginRight: "12px",
          }}
        />
      )}
      <span
        style={{
          fontSize: "14px",
          color: "#323232",
        }}
      >
        {name}
      </span>
    </div>
  );
}
